import { ReactElement } from 'react';
import parse from 'html-react-parser';
import cn from 'classnames';

import styles from './Tooltip.module.scss';
import { Icon } from '../Icon/Icon';
import { getDataTest } from '../../utils/dataTests';

interface TooltipProps {
    text: string;
    className?: string;
    position?: 'left' | 'right' | 'center';
    boxClassName?: string;
}

export const Tooltip = ({
    text,
    position = 'right',
    className,
    boxClassName,
    ...props
}: TooltipProps): ReactElement | null => {
    return (
        <div className={cn(styles.wrapper, className)} {...props}>
            <div
                className={cn(styles.tooltipBox, boxClassName, styles[`tooltipBox-${position}`])}
                data-test={getDataTest(props, 'Text')}
            >
                {parse(text)}
            </div>
            <div className={styles.tooltipTrigger} data-test={getDataTest(props, 'Icon')}>
                <Icon name="info" className="color--purple" data-test="icon" />
            </div>
        </div>
    );
};
